import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiBrain, FiZap, FiHeart } = FiIcons;

const EMDRSection = () => {
  return (
    <section className="py-16 bg-gradient-to-r from-purple-600 to-blue-600 text-white">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="max-w-4xl mx-auto text-center"
        >
          <div className="flex justify-center mb-6">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-full">
              <SafeIcon icon={FiBrain} className="text-5xl text-yellow-300" />
            </div>
          </div>
          
          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            EMDR: Reprocesamiento para tu Bienestar Profundo
          </h2>
          
          <p className="text-xl text-blue-100 leading-relaxed max-w-3xl mx-auto">
            Una técnica respaldada por la ciencia que permite reprocesar emociones y bloqueos del pasado 
            para liberarte de ellos y avanzar hacia el bienestar.
          </p>
          
          <div className="grid md:grid-cols-3 gap-6 mt-12">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl"
            >
              <SafeIcon icon={FiZap} className="text-3xl text-yellow-300 mb-3 mx-auto" />
              <h3 className="font-bold mb-2">Científicamente Probado</h3>
              <p className="text-sm text-blue-100">Respaldado por investigación clínica</p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl"
            >
              <SafeIcon icon={FiHeart} className="text-3xl text-yellow-300 mb-3 mx-auto" />
              <h3 className="font-bold mb-2">Sanación Profunda</h3>
              <p className="text-sm text-blue-100">Libera bloqueos emocionales</p>
            </motion.div>
            
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.3 }}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-xl"
            >
              <SafeIcon icon={FiBrain} className="text-3xl text-yellow-300 mb-3 mx-auto" />
              <h3 className="font-bold mb-2">Transformación Real</h3>
              <p className="text-sm text-blue-100">Resultados duraderos y profundos</p>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default EMDRSection;